export default __webpack_public_path__ + "static/media/drawing-woman4-focusfill.ee71810c.svg";